// components/trade/common/NumericFormatCustom.tsx
import { forwardRef } from "react";
import { NumericFormat, NumericFormatProps } from "react-number-format";

// CONSTANTS
import { STABLE_COIN_CODES } from "./constants";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  maxValue?: number;
  onMaxExceeded?: () => void;
  preventLeadingZeros?: boolean; // Optional flag to enable the leading zero check
}

export const NumericFormatCustom = forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, maxValue, onMaxExceeded, preventLeadingZeros = false, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          // The Targets version handles empty strings differently
          const value = preventLeadingZeros && values.value === "" ? "" : values.value;

          onChange({
            target: {
              name: props.name,
              value: value,
            },
          });
        }}
        isAllowed={
          preventLeadingZeros
            ? (values) => {
                const { formattedValue } = values;

                // Allow empty values
                if (!formattedValue || formattedValue === "") {
                  return true;
                }

                // Check if it starts with 0 and the next character is not a decimal point
                if (formattedValue && formattedValue.length > 1) {
                  if (formattedValue[0] === "0" && formattedValue[1] !== ".") {
                    return false;
                  }
                }
                return true;
              }
            : undefined
        }
        thousandSeparator
        allowLeadingZeros={false}
        allowNegative={false}
      />
    );
  },
);

export const getCurrencyCode = (currencyCode: string) => {
  return STABLE_COIN_CODES.includes(currencyCode) ? "USD" : currencyCode.toUpperCase();
};
